import NiceModal from "@ebay/nice-modal-react";
import { CloseModalOnRouteChange } from "./NiceModalProvider";

export default function NiceModalProvider({ children }) {
  return (
    <NiceModal.Provider>
      <CloseModalOnRouteChange>{children}</CloseModalOnRouteChange>
    </NiceModal.Provider>
  );
}
